
<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div class="top-right-button-container">
            <b-button v-b-modal.admission_form @click="edit = false" variant="primary" size="sm"
                      class="top-right-button"
                      v-text="'ADD NEW'"/>
        </div>

        <div class="d-flex flex-row">
            <span class="iconsminds-add mr-3 menu-icon-style" style="font-size: 23px;"/>

            <piaf-breadcrumb heading="Clients Admission"/>

<!--            <p class="my-auto">-->
<!--                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,-->
<!--                repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                officiis quia quos rem totam vitae.-->
<!--            </p>-->
        </div>

        <div class="my-2">
            <div class="d-block d-md-inline-block pt-1">
                <b-dropdown :text="'Order by: ' + meta.order_by"
                            variant="outline-dark" class="mr-1 float-md-left btn-group" size="xs">

                    <b-dropdown-item v-for="(field,index) in table_fields.slice(0, -1)"
                                     v-if="field.sortable === true" :key="index"
                                     @click="changeOrderBy(field.key, field.label)">{{ field.label }}
                    </b-dropdown-item>
                </b-dropdown>

                <div class="search-sm d-inline-block float-md-left ml-1 align-top">
                    <b-input placeholder="Search" @input="searchAdmission" v-model="meta.search"/>
                </div>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{ meta.from }}-{{ meta.to }} of {{ meta.total }}</span>

                <b-dropdown right :text="meta.per_page.toString()" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="separator mb-4"></div>

        <b-card class="mb-4" :title="'List of Admitted Clients'">
            <b-refresh-button class="text-data-link" @click="refreshData"/>
            <b-table :key="tableKey" show-empty no-sort-reset class="vuetable" :sort-by="meta.sort_by"
                     :sort-desc="meta.sort_desc" @sort-changed="changeSorting" :per-page="meta.per_page"
                     :current-page="meta.current_page" :fields="table_fields" :items="fetchAdmissions">

                <template v-slot:cell(id)="data">
                    <span v-text="data.item.data.attributes.code"/>
                </template>

                <template v-slot:cell(client)="data">
                    <router-link class="text-data-link" :to="data.item.data.attributes.client_link"
                                 v-text="data.item.data.attributes.client"/>
                </template>

                <template v-slot:cell(facility)="data">
                    <span v-text="data.item.data.attributes.facility"/>
                </template>

                <template v-slot:cell(unit)="data">
                    <span v-text="data.item.data.attributes.unit"/>
                </template>

                <template v-slot:cell(move_in)="data">
                    <span v-text="data.item.data.attributes.move_in"/>
                </template>

                <template v-slot:cell(move_out)="data">
                    <span v-text="data.item.data.attributes.move_out"/>
                </template>

                <template v-slot:cell(staying_for)="data">
                    <span v-text="data.item.data.attributes.staying_for"/>
                </template>

                <template v-slot:cell(status)="data">
                    <b-badge pill style="width: 73px;"
                             :variant="admissionStatusColor(data.item.data.attributes.status)">
                        {{ data.item.data.attributes.status }}
                    </b-badge>
                </template>

                <template v-slot:cell(actions)="data">
                    <b-dropdown variant="empty" class="my-auto dropright" size="xs"
                                menu-class="mt-2" style="width: 75px;" right no-caret>
                        <template slot="button-content">
                            <i class="btn-circle simple-icon-options-vertical"/>
                        </template>

                        <b-dropdown-item v-if="false"
                            @click="editAdmission(data.item.admission_id)">
                            Edit
                        </b-dropdown-item>

                        <b-dropdown-item v-if="data.item.data.attributes.status.toLowerCase() !== 'discharged'"
                            @click="transferAdmission(data.item)">
                            Transfer
                        </b-dropdown-item>

                        <b-dropdown-item v-if="data.item.data.attributes.status.toLowerCase() !== 'discharged'"
                                         @click="dischargeAdmission(data.item)">
                            Discharge
                        </b-dropdown-item>

                        <b-dropdown-item @click="deleteAdmission(data.item)">
                            Delete
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>

            <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                          v-model="meta.current_page">
                <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                </template>

                <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                </template>

                <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                </template>

                <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                </template>
            </b-pagination>
        </b-card>

        <AdmissionFormModal :edit="edit" @updated="tableKey++"/>
        <TransferFormModal v-if="admission && transferClicked" :admission="admission" @closed="handleTransferClosed" @transferred-client="tableKey++"/>
        <DischargeFormModal v-if="admission && dischargeClicked" :admission="admission" @closed="handleDischargeClosed" @discharged-client="tableKey++"/>
        <AdmissionDeleteModal v-if="admission && deleteClicked" :admission="admission" @closed="handleDeleteClosed" @deleted-admission="tableKey++"/>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import AdmissionFormModal from "./modals/AdmissionFormModal";
import DischargeFormModal from "./modals/DischargeFormModal";
import TransferFormModal from "./modals/TransferFormModal";
import AdmissionDeleteModal from "./modals/AdmissionDeleteModal";


export default {
    name: "AdmissionsList",

    components: {
        TransferFormModal,
        AdmissionFormModal,
        DischargeFormModal,
        AdmissionDeleteModal,
    },

    data() {
        return {
            loading: true,
            tableKey: 0,
            admission: null,
            edit: false,
            transferClicked: false,
            dischargeClicked: false,
            deleteClicked: false,
        }
    },

    computed: {
        ...mapGetters({
            table_fields: 'getAdmissionTableFields',
            meta: 'getAdmissionsMeta',

        }),
    },

    methods: {
        handleTransferClosed() {
            this.admission = null;
            this.transferClicked = false;
        },
        handleDischargeClosed() {
            this.admission = null;
            this.dischargeClicked    = false;
        },
        handleDeleteClosed() {
            this.admission = null;
            this.deleteClicked = false;
        },
        changeSorting(event) {
            (event.sortDesc ? this.meta.sort = 'desc' : this.meta.sort = 'asc') && (this.meta.sort_by = event.sortBy);
        },

        changeOrderBy(key, label) {
            this.meta.order_by = label;
            this.meta.sort_by = key;
        },

        searchAdmission: _.debounce(function (event) {
            // if (this.meta.search && this.meta.search.length >= 3) {
                this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
            // }
        }, 300),

        changePageSize(per_page) {
            this.meta.per_page = per_page;
        },

        refreshData() {
            this.$store.commit('resetAdmissionsMeta');
            this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
        },

        fetchAdmissions() {
            return this.$store.dispatch('fetchAdmissions')
                .then(admissions => {
                    return admissions.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        admissionStatusColor: status => {
            if (status.toLowerCase() === 'admitted') return 'success'
            else return 'danger'
        },

        editAdmission(admission_id) {
            this.edit = true;

            this.$store.dispatch('fetchEditAdmission', admission_id)
                .finally(response => {
                    this.$bvModal.show('admission_form');
                });
        },

        transferAdmission(admission) {
            this.admission = admission;
            this.transferClicked = true;

            setTimeout(() => {
                this.$bvModal.show('transfer_form');
            }, 1);
        },

        dischargeAdmission(admission) {
            this.admission = admission;
            this.dischargeClicked = true;

            setTimeout(() => {
                this.$bvModal.show('discharge_form');
            }, 1);
        },

        deleteAdmission(admission) {
            this.admission = admission;
            this.deleteClicked = true;

            setTimeout(() => {
                this.$bvModal.show('admission_delete');
            }, 1);
        },
    },
}
</script>

<style scoped>

</style>
